<template>
  <div class="accueil" :class="{ marginBandeau: $store.state.bandeau != 0 }">
    <div class="contenuPanel nouveauxMembres">
      <h2 class="">
        NOUVEAUX MEMBRES
      </h2>
      <div class="gridContainer">
        <div :key="sub.id" v-for="sub in lastSubs" class="gridItem">
          <PhotoAccueil :prf="sub" />
        </div>
      </div>
    </div>

    <h2 class="espaceTop">
      AVERTISSEMENT IMPORTANT POUR VOTRE SECURITE
    </h2>
    <div class="avertissement">
      <p>
        <strong>Attention aux escroqueries en ligne !</strong> Des escrocs venant principalement de Côte d'Ivoire
        sévissent sur le site en créant de faux profils dans le but de vous escroquer de l'argent par la suite. Pour
        votre sécurité, nous vous recommandons de prendre en compte les conseils suivants.
      </p>
      <ul>
        <li>
          <p>
            Méfiez vous des profils sans photo, ni annonce. Les escrocs savent que nous vérifions les photos et
            utilisent souvent des profils vides pour tenter d'engager une conversation
          </p>
        </li>

        <li>
          <p>
            Privilégiez les dialogues sur {{ $store.state.siteConst.name }}. Les escrocs savent que nous supprimons
            leurs profils très rapidement, ils vous proposeront donc très rapidement de continuer le dialogue par mail,
            par MSN, Facebook, Skype ou autre. Méfiez-vous des profils inconnus qui vous demandent très rapidement de
            passer sur une autre messagerie.
          </p>
        </li>

        <li>
          <p>
            Si après une conversation avec un profil, ce profil vous semble douteux, n'hésitez pas à le signaler en
            utilisant le petit bouton.
          </p>
        </li>

        <li>
          <p>
            Le plus important : quoi qu'il arrive
            <strong>NE DONNEZ JAMAIS D'ARGENT A UN INCONNU RENCONTRÉ SUR INTERNET</strong>. Quelque soit le prétexte ou
            la raison, ne donnez jamais d'argent à une personne que vous ne connaissez pas en chair et en os, il s'agit
            dans 100% des cas d'une arnaque et vous ne reverrez jamais votre argent. Les escrocs vous demanderont
            souvent de transférer de l'argent en utilisant Western Union.
          </p>
        </li>
      </ul>
    </div>

    <h2 class="espaceTop">
      DERNIERS CONNECTES
    </h2>

    <div class="derniersInscrits">
      <div class="gridContainer">
        <div class="gridItem" v-for="lastCo in lastCos" v-bind:key="lastCo.id">
          <PhotoAccueil :prf="lastCo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import PhotoAccueil from "@/components/PhotoAccueil";

export default {
  name: "Accueil",

  components: { PhotoAccueil },
  data() {
    return {
      lastCos: [],
      lastSubs: []
    };
  },

  mounted: function() {
    idyuJsonRpc("getLastConnectedProfiles", 6).then(json => {
      this.lastCos = json;
    });

    idyuJsonRpc("getNewestProfiles", 12).then(json => {
      this.lastSubs = json;
    });
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.espaceTop {
  margin-top: 15px;
}

#boxGaucheAccueil {
  position: relative;
}

ul {
  padding-left: 20px;
}

.derniersInscrits {
  text-align: center;
  border-top-width: 2px;
  border-top-style: solid;
  border-bottom-width: 2px;
  border-bottom-style: solid;
  padding-top: 10px;
  padding-bottom: 10px;
  position: relative;
  border-top-color: #ddd;
  border-bottom-color: #ddd;
}

.flecheDroite {
  position: absolute;
  right: 0px;
  top: 50px;
}

.flecheGauche {
  position: absolute;
  left: 0px;
  top: 50px;
}

.pseudo.tinywindow {
  margin-top: 0px;
  margin-bottom: 10px;
  padding: 0px;
}

.nouveauxMembres {
  padding: 5px;
}

#boxGaucheAccueil table {
  border-spacing: 0px;
}

.derniersInscrits table {
  border-spacing: 3px 0px;
  margin: 0 auto;
}

#birth .submitButton {
  text-align: center;
  margin-top: 15px;
}

.nouveauxMembres table,
.derniersInscrits table {
  border-spacing: 1px;
  margin: 0 auto;
}

#conteneurVoyage {
  display: block !important;
}

.gridContainer {
  display: flex;
  flex-wrap: wrap;
  justify-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.gridItem {
  margin: 10px;
}

h2 {
  margin-top: 0;
  color: #e52c85;
  border-bottom: 1px #ddd solid;
}
</style>
